import getBulkDiscount from './getBulkDiscount';
import { getBulkDiscountsForVariantOption } from './getBulkDiscountsForVariantOption';

export default function getOneTimeVariantsAmount(
  selectedVariants,
  checkoutQuantity,
  type,
  bulkDiscounts = [],
) {
  if (!selectedVariants || !selectedVariants.length)
    return { oneTimeVariantsAmount: 0, oneTimeVariantsDiscountAmount: 0 };

  return selectedVariants.reduce(
    (acc, variant) => {
      if (!variant || (!variant.selectedOption && !variant.selectedOptions)) {
        return acc;
      }

      let variantAmount = 0;
      let variantDiscountAmount = 0;

      if (variant.selectionType === 'single') {
        const { additionalChargeAmount } = variant.selectedOption;

        if (type === 'subscription' && variant.selectedOption.type !== 'one_time') {
          return acc;
        }

        const amount = variant.increasesWithQuantity
          ? additionalChargeAmount * checkoutQuantity
          : additionalChargeAmount;

        const bulkDiscountsToApply = getBulkDiscountsForVariantOption(
          bulkDiscounts,
          variant.selectedOption._id,
        );

        const { bulkDiscountAmount } = getBulkDiscount(
          bulkDiscountsToApply,
          variant.increasesWithQuantity ? checkoutQuantity : 1,
          amount,
        );

        variantAmount = amount;
        variantDiscountAmount = bulkDiscountAmount;
      } else if (variant.selectionType === 'quantity') {
        variantAmount = variant.selectedOptions.reduce((optionAcc, selectedOption) => {
          if (!selectedOption || selectedOption.quantity === 0) {
            return optionAcc;
          }

          if (type === 'subscription' && selectedOption.type !== 'one_time') {
            return optionAcc;
          }

          const amount = selectedOption.additionalChargeAmount * selectedOption.quantity;

          const bulkDiscountsToApply = getBulkDiscountsForVariantOption(
            bulkDiscounts,
            selectedOption._id,
          );

          const { bulkDiscountAmount } = getBulkDiscount(
            bulkDiscountsToApply,
            selectedOption.quantity,
            amount,
          );

          variantDiscountAmount += bulkDiscountAmount;
          return optionAcc + amount;
        }, 0);
      } else if (variant.selectionType === 'multiple') {
        variantAmount = variant.selectedOptions.reduce((optionAcc, selectedOption) => {
          if (!selectedOption || selectedOption.quantity === 0) {
            return optionAcc;
          }

          if (type === 'subscription' && selectedOption.type !== 'one_time') {
            return optionAcc;
          }

          const amount = variant.increasesWithQuantity
            ? selectedOption.additionalChargeAmount * checkoutQuantity
            : selectedOption.additionalChargeAmount;

          const bulkDiscountsToApply = getBulkDiscountsForVariantOption(
            bulkDiscounts,
            selectedOption._id,
          );

          const { bulkDiscountAmount } = getBulkDiscount(
            bulkDiscountsToApply,
            variant.increasesWithQuantity ? checkoutQuantity : selectedOption.quantity,
            amount,
          );

          variantDiscountAmount += bulkDiscountAmount;
          return optionAcc + amount;
        }, 0);
      }

      return {
        oneTimeVariantsAmount: acc.oneTimeVariantsAmount + variantAmount,
        oneTimeVariantsDiscountAmount: acc.oneTimeVariantsDiscountAmount + variantDiscountAmount,
      };
    },
    { oneTimeVariantsAmount: 0, oneTimeVariantsDiscountAmount: 0 },
  );
}
